module.exports = __webpack_public_path__ + "static/img/second.d5a9ec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/solution/second.png
// module id = x9m2
// module chunks = 1